import { colors, fonts } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';
import { useCallback, useMemo } from 'react';
import LeadTrackingParams from 'types/Apis/LeadTrackingParams';
import toggleEvent from 'lib/Tracking/Vdp/SellerSnapshot/ToggleEvent';
import useEvents from 'lib/hooks/useEvents';
import showMoreIcon from './show-more-icon.svg';
import showLessIcon from './show-less-icon.svg';

function SmsVariantShowButton({
  isTruncated,
  expand,
  trackingParams,
}: {
  isTruncated: boolean;
  expand: () => void;
  trackingParams?: LeadTrackingParams;
}): JSX.Element {
  const { t } = useTranslation();
  const logger = useEvents();

  const handleClick = useCallback((): void => {
    logger.log(toggleEvent({ isTruncated, trackingParams }));
    expand();
  }, [logger, isTruncated, trackingParams, expand]);

  const buttonContent = useMemo(
    () => ({
      text: isTruncated ? t('vdp.showMore') : t('vdp.showLess'),
      icon: isTruncated ? <div className="show-more-icon" /> : <div className="show-less-icon" />,
    }),
    [isTruncated, t]
  );

  return (
    <button onClick={handleClick} className="show-button">
      {buttonContent.text}
      {buttonContent.icon}
      <style jsx>{`
        .show-button {
          font-family: ${fonts.default};
          font-size: 16px;
          font-weight: 600;
          color: ${colors.BLACK};
          background-color: transparent;
          border: none;
          cursor: pointer;
          text-align: left;
          padding: 0;
          margin: 0;
          width: 100%;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .show-more-icon {
          width: 13px;
          height: 8.5px;
          background-image: url(${showMoreIcon});
          background-size: contain;
          background-repeat: no-repeat;
        }

        .show-less-icon {
          width: 13px;
          height: 8.5px;
          background-image: url(${showLessIcon});
          background-size: contain;
          background-repeat: no-repeat;
          rotate: 180deg;
        }
      `}</style>
    </button>
  );
}

export default SmsVariantShowButton;
